<template><div><h1 id="adressaktualisierung-parametrisierung" tabindex="-1"><a class="header-anchor" href="#adressaktualisierung-parametrisierung"><span>Adressaktualisierung Parametrisierung</span></a></h1>
<p>Adressaktualisierung Parametrisierung — Parametrisierung der Adressaktualisierung</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>In dieser Tabelle werden Status und Ereignisse für die Adressaktualisierung definiert.</p>
<p>Pfad: <code v-pre>Systemverwaltung → Tabellen → Systemtabellen → Parametrisierung Adressaktualisierung</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Aktualisierungsdienst</dt>
<dd>
<p>Auswahl des Aktualisierungsdienstes</p>
</dd>
<dt>Adressstamm</dt>
<dd>
<p>Auswahl des Adressstamms (Parametrisierungszeile gilt für den ausgewählten Adressstamm)</p>
</dd>
<dt>Status</dt>
<dd>
<p>Definition des Status
Adresspflege Online</p>
<table>
<thead>
<tr>
<th>Status</th>
<th>Bedeutung</th>
</tr>
</thead>
<tbody>
<tr>
<td>1</td>
<td>offizieller Umzug</td>
</tr>
<tr>
<td>2</td>
<td>weggezogen</td>
</tr>
<tr>
<td>4</td>
<td>gestorben</td>
</tr>
</tbody>
</table>
<p>Adresspflege über Webservice</p>
<table>
<thead>
<tr>
<th>Status</th>
<th>Bedeutung</th>
</tr>
</thead>
<tbody>
<tr>
<td>1</td>
<td>Personentreffer</td>
</tr>
<tr>
<td>2</td>
<td>Haushalttreffer</td>
</tr>
<tr>
<td>3</td>
<td>Firmentreffer</td>
</tr>
<tr>
<td>4</td>
<td>Umzug</td>
</tr>
<tr>
<td>25</td>
<td>Todesfall</td>
</tr>
<tr>
<td>26</td>
<td>Umzug ins Ausland</td>
</tr>
<tr>
<td>27</td>
<td>abgelaufener Nachsendeauftrag</td>
</tr>
<tr>
<td>50</td>
<td>nicht erkannte Adresse</td>
</tr>
<tr>
<td>51</td>
<td>unbekanntes Gebäude</td>
</tr>
<tr>
<td>104</td>
<td>Umzug im Haushalt (in funtrade als Umzug interpretiert)</td>
</tr>
</tbody>
</table>
<p>CRIF</p>
<table>
<thead>
<tr>
<th>Status</th>
<th>Bedeutung</th>
</tr>
</thead>
<tbody>
<tr>
<td>umzug</td>
<td>offizieller Umzug</td>
</tr>
<tr>
<td>verstorben</td>
<td>Person ist verstorben</td>
</tr>
<tr>
<td>identity-high</td>
<td>Person gefunden (hoch)</td>
</tr>
<tr>
<td>identity-medium</td>
<td>Person gefunden (mittel)</td>
</tr>
<tr>
<td>identity-low</td>
<td>Person gefunden (niedrig)</td>
</tr>
<tr>
<td>identity-Identity</td>
<td>Person gefunden (in unterschiedlichem Haus, Strasse, Ort)</td>
</tr>
<tr>
<td>identityWithConflictingHouse</td>
<td>Person gefunden (in unterschiedlichem Haus)</td>
</tr>
<tr>
<td>identityWithConflictingStreet</td>
<td>Person gefunden (an unterschiedlicher Strasse)</td>
</tr>
<tr>
<td>identityWithConflictingCity</td>
<td>Person gefunden (in unterschiedlichem Ort)</td>
</tr>
<tr>
<td>lastNameInHouse</td>
<td>Nur Nachname im Haus gefunden</td>
</tr>
<tr>
<td>houseConfirmed</td>
<td>Haus, Strasse, Ort verifiziert</td>
</tr>
<tr>
<td>streetConfirmed</td>
<td>Strasse, Ort verifiziert (Haus nicht verifiziert)</td>
</tr>
<tr>
<td>cityConfirmed</td>
<td>Ort verifiziert (Haus, Strasse nicht verifiziert)</td>
</tr>
<tr>
<td>notConfirmed</td>
<td>Nichts verifiziert</td>
</tr>
</tbody>
</table>
<p>Matchmove</p>
<table>
<thead>
<tr>
<th>Status</th>
<th>Bedeutung</th>
</tr>
</thead>
<tbody>
<tr>
<td>1</td>
<td>offizieller Umzug</td>
</tr>
<tr>
<td>2</td>
<td>weggezogen</td>
</tr>
<tr>
<td>3</td>
<td>weggezogen</td>
</tr>
<tr>
<td>4</td>
<td>gestorben</td>
</tr>
<tr>
<td>5</td>
<td>amtliche Mutation</td>
</tr>
<tr>
<td>6</td>
<td>Postfachänderung</td>
</tr>
</tbody>
</table>
<p>Multisource</p>
<table>
<thead>
<tr>
<th>Status</th>
<th>Beschreibung</th>
</tr>
</thead>
<tbody>
<tr>
<td>2</td>
<td>Korrektur (normiert, Ergänzung)</td>
</tr>
<tr>
<td>3</td>
<td>Adressänderung (Umzug)</td>
</tr>
</tbody>
</table>
</dd>
<dt>Ereignis</dt>
<dd>
<p>Auswahl des Ereignisses</p>
</dd>
<dt>Ereignisposition</dt>
<dd>
<p>Auswahl der Ereignisposition</p>
</dd>
<dt>Ereignisstatus</dt>
<dd>
<p>Auswahl des Ereignisstatus</p>
</dd>
<dt>bei Adresssperre</dt>
<dd>
<p>Einstellung, ob bei Adresssperre die Adresse entsperrt werden soll. Dieser Parameter ist nur für den Aktualisierungsdienst &quot;CRIF&quot; vorgesehen.</p>
</dd>
</dl>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/referenz/refs/ft.refdata.adressaktualisierung.html" title="Adressaktualisierung">Adressaktualisierung</RouteLink></p>
</div></template>


